module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Burger-dff29c5c8a912b618591c23a9d3a174b.svg";